/**
 * OpenList 搜索结果组件
 */

"use client"

import { Button } from "@/components/ui/button"
import { Download, Eye, Loader2 } from "lucide-react"
import type { OpenListFile } from "@/types/openlist"
import { formatFileSize } from "@/lib/utils/openlist-file-utils"
import { OpenListFileIcon } from "./openlist-file-icon"

interface OpenListSearchResultsProps {
  searchResults: OpenListFile[]
  isDownloading: Set<string>
  onPreview: (file: OpenListFile) => void
  onDownload: (file: OpenListFile) => void
}

export function OpenListSearchResults({
  searchResults,
  isDownloading,
  onPreview,
  onDownload
}: OpenListSearchResultsProps) {
  if (searchResults.length === 0) {
    return null
  }

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium mb-3">
        搜索结果 ({searchResults.length})
      </h3>
      <div className="space-y-2">
        {searchResults.map(file => (
          <div key={file.path} className="border rounded-lg p-3 hover:bg-gray-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2 flex-1">
                <OpenListFileIcon fileType={file.fileType} />
                <div className="flex-1">
                  <div className="font-medium">{file.name}</div>
                  <div className="text-sm text-gray-500">
                    {formatFileSize(file.size)} • {file.fileType}
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onPreview(file)}
                >
                  <Eye className="h-4 w-4 mr-1" />
                  预览
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onDownload(file)}
                  disabled={isDownloading.has(file.path)}
                >
                  {isDownloading.has(file.path) ? (
                    <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                  ) : (
                    <Download className="h-4 w-4 mr-1" />
                  )}
                  下载
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
